import SearchInsights from 'search-insights';
import { CONFIG } from '../../config';

export const initializeInsights = () => {
  SearchInsights('init', { appId: CONFIG.ALGOLIA_APPLICATION_ID, apiKey: CONFIG.ALGOLIA_API_KEY });
};
